import toHeadersFromHttpHeaders from './toHeadersFromHttpHeaders';
import { HttpResponse } from '../interfaces';
import { makeResponseBody } from './response';

const toResponseFromHttpResponse = async (
  res: HttpResponse,
  url: RequestInfo
): Promise<Response> => {
  return new ResponseWrapper(res, url);
};

class ResponseWrapper extends Response {
  original: HttpResponse;
  url: string;
  constructor(res: HttpResponse, url: RequestInfo) {
    super(makeResponseBody(res.body), {
      headers: toHeadersFromHttpHeaders(res.headers),
      status: res.status,
      statusText: res.statusText
    });
    this.original = res;
    this.url = url.toString();
  }

  get trailer(): Promise<Headers> {
    return Promise.resolve(this.headers);
  }

  clone(): Response {
    return new ResponseWrapper(this.original, this.url);
  }
}

export default toResponseFromHttpResponse;
